var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, "max-width": "560", persistent: "" },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "rpd-save-dialog" },
        [
          _c("v-card-title", { staticClass: "dialog__title" }, [
            _c("span", [_vm._v(_vm._s(_vm.state.title))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog__banner", class: _vm.state.cls }, [
            _c(
              "i",
              {
                staticClass: "material-icons",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v(_vm._s(_vm.state.icon))]
            ),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.detail))]),
          ]),
          _vm._v(" "),
          _c("v-card-text", [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { attrs: { for: "rpd-save-name" } }, [
                  _vm._v("Query name"),
                ]),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    id: "rpd-save-name",
                    value: _vm.name,
                    autofocus: "",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.name = $event
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { attrs: { for: "rpd-save-description" } }, [
                  _vm._v("Description"),
                ]),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    id: "rpd-save-description",
                    value: _vm.description,
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.description = $event
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field field--inline" },
              [
                _c("v-checkbox", {
                  attrs: {
                    "input-value": _vm.isShared,
                    "hide-details": "",
                    label: "Share with everyone in this tenant",
                  },
                  on: {
                    change: function ($event) {
                      _vm.isShared = $event
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "field-note" }, [
              _vm._v(
                "\n        A shared query can be reopened by any user in this tenant. Deleting it stays with the\n        owner.\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", disabled: _vm.busy },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", false)
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.state.button,
                  attrs: { disabled: !_vm.canSave, loading: _vm.busy },
                  on: { click: _vm.submit },
                },
                [_vm._v("\n        " + _vm._s(_vm.state.label) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }